export default __webpack_public_path__ + "static/media/icon_heart_gray.19ff6b2c.svg";